/* eslint-disable no-console */
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const getDamFolderGroup = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DAM_FOLDER_GROUP.GET}`, {
      params: data,
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getDamFolderGroupById = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DAM_FOLDER_GROUP.GET_BY_ID}${params.id}`, {
      params: { ...params },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addNewDamFolder = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DAM_FOLDER_GROUP.CREATE}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateDamFolder = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.DAM_FOLDER_GROUP.UPDATE}${data.id}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteDamFolderGroup = async (payload) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.DAM_FOLDER_GROUP.DELETE}`, {
      data: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getFilesSuggestions = async (query) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DAM_FOLDER_GROUP.FILTER_SEARCH_FILES}`, {
      params: { ...query },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const activeInActiveDamGroup = async (params) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.DAM_FOLDER_GROUP.ACTIVE_INACTIVE_DAM}`, {
      ...params,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteFolderImage = async (id) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.DAM_FOLDER_GROUP.DELETE_FOLDER_IMAGE}/${id}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const removeFolderFiles = async (id, deletedIds) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.DAM_FOLDER_GROUP.DELETE_FOLDER_FILE}/${id}`, {
      data: { deletedIds },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const duplicateDamFolder = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DAM_FOLDER_GROUP.DUPICATE_DAM_FOLDER}/${data?.id}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const archiveUnarchiveFolders = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DAM_FOLDER_GROUP.ARCHIVE_UNARCHIVE_DAM_FOLDER}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchDamAcrhivedFolder = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DAM_FOLDER_GROUP.FETCH_ARCHIVED_FOLDER}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchDamDeletedFolders = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DAM_FOLDER_GROUP.FETCH_DELETED_FOLDER}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
